export default __webpack_public_path__ + "static/gotham-black-a3e1d5b7328a6dec0368f3f9e5316900.woff2";